module.exports = __webpack_public_path__ + "img/MXN_1.15e3608a.png";